import { render } from "./TarotDetailDescArea.vue?vue&type=template&id=5e38d7da&scoped=true"
import script from "./TarotDetailDescArea.vue?vue&type=script&lang=js"
export * from "./TarotDetailDescArea.vue?vue&type=script&lang=js"

import "./TarotDetailDescArea.vue?vue&type=style&index=0&id=5e38d7da&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e38d7da"]])

export default __exports__